import React from 'react'
import Navbar from '../../component/Other/Navbar'
import Contact from '../../component/Page/Contact'
import Footer from '../../component/Page/Footer'
import Slider from 'react-slick';
import { NavLink } from 'react-router-dom';
import { useState } from 'react';
import Faq from '../../component/Page/Faq';

const Plan = () => {
    const data = [
        {
            title: "Exclusive Venue Hire in the City Centre of Glasgow",
            path_1: "2",
            path_2: "8",
            path_3: "12",
            type: "text",
        },
        {
            title: "Complimentary DJ for parties",
            path_1: "50",
            path_2: "100",
            path_3: "180",
            type: "text",
        },
        {
            title: "Personalised menus",
            path_1: "./../images/Icon.png",
            path_2: "./../images/Icon.png",
            path_3: "./../images/Icon.png",
            type: "img",
        },
        {
            title: "In house PA/microphones for speeches",
            path_1: "./../images/Icon.png",
            path_2: "./../images/Icon.png",
            path_3: "./../images/Icon.png",
            type: "img",
        },
        {
            title: "Dedicated Events Coordinator",
            path_1: "./../images/Icon.png",
            path_2: "./../images/Icon.png",
            path_3: "./../images/Icon.png",
            type: "img",
        },
        {
            title: "Dedicated Events Coordinator",
            path_1: "./../images/Icon.png",
            path_2: "./../images/Icon.png",
            path_3: "./../images/Icon.png",
            type: "img",
        },
        {
            title: "Dedicated Events Coordinator",
            path_1: "./../images/Icon.png",
            path_2: "./../images/Icon.png",
            path_3: "./../images/Icon.png",
            type: "img",
        },
        {
            title: "In house PA/microphones for speeches",
            path_1: "./../images/Icon.png",
            path_2: "./../images/Icon.png",
            path_3: "./../images/Icon.png",
            type: "img",
        },
        {
            title: "Dedicated Events Coordinator",
            path_1: "./../images/Icon.png",
            path_2: "./../images/Icon.png",
            path_3: "./../images/Icon.png",
            type: "img",
        },

    ]

    const settings = {
        dots: true,
        arrows: false,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 780,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
        ]
    };
    const settings2 = {
        dots: false,
        arrows: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    const [nav1, setNav1] = useState();
    const [nav2, setNav2] = useState();
    return (
        <div className="overflow-hidden">
            <Navbar type={"dark"} />

            <section>
                <div className="container">
                    <div className="mb-5 text-center">
                        <h2 className="medium font__size--48 text__48-1024 text__48-md text__48-sm text__48-xx play">Compare Our Plane and <br />
                            Find Your</h2>
                        <div className="d-flex align-items-center justify-content-center normal font__size--24 text__24-1024 text-capitalize color__brown mt-3">
                            <img src="./../images/Vector 2.png" alt="" />
                            <span className="mx-3">Pricing Plan</span>
                            <img src="./../images/Vector 1.png" alt="" />
                        </div>
                    </div>



                    <Slider {...settings} asNavFor={nav2} ref={(slider1) => setNav1(slider1)} className="wrapper__slider-pricing-plan mb-5">
                        <div className="items">
                            <div className="wrapper__plan-price">
                                <h5 className="medium font__size--24 text__24-1024 play mb-3">Local event</h5>
                                <h2 className="medium font__size--24 text__24-1024 mb-3 play">$ 999.00 USD</h2>
                                <p className="normal font__size--16 mb-0">Wedding Planning Assistant Expands with Three New Localized Services
                                </p>

                                <a href="#!" className="medium font__size--14 btn btn__outlined--darkgreen color__darkgreen shadow h__white  no__opacity w-100 rounded-0 mt-4">Choose Plan</a>
                            </div>
                        </div>
                        <div className="items">
                            <div className="wrapper__plan-price active">
                                <h5 className="medium font__size--24 text__24-1024 play mb-3">International event</h5>
                                <h2 className="medium font__size--24 text__24-1024 mb-3 play">$ 9,999.00 USD</h2>
                                <p className="normal font__size--16 mb-0">Wedding Planning Assistant Expands with Three New Localized Services
                                </p>

                                <a href="#!" className="medium font__size--14 btn btn__outlined--darkgreen color__darkgreen shadow h__white  no__opacity w-100 rounded-0 mt-4">Choose Plan</a>
                            </div>
                        </div>
                        <div className="items">
                            <div className="wrapper__plan-price">
                                <h5 className="medium font__size--24 text__24-1024 play mb-3">International event</h5>
                                <h2 className="medium font__size--24 text__24-1024 mb-3 play">$ 9,999.00 USD</h2>
                                <p className="normal font__size--16 mb-0">Wedding Planning Assistant Expands with Three New Localized Services
                                </p>
                                <a href="#!" className="medium font__size--14 btn btn__outlined--darkgreen color__darkgreen shadow h__white  no__opacity w-100 rounded-0 mt-4">Choose Plan</a>
                            </div>
                        </div>
                    </Slider>

                    <div className="d-lg-none">
                        <Slider asNavFor={nav1}
                            ref={(slider2) => setNav2(slider2)} {...settings2} className="wrapper__slider-pricing-detail">
                            <div className="items">
                                <div className="wrapper__table-compare-group">
                                    <table class="table head text-center">
                                        <col class="w-f-first" />
                                        <thead>
                                            <tr className='text-center medium font__size--24 text__24-1024 play'>
                                                <th scope="col" className="text-left medium">Characteristic</th>
                                                <th scope="col" className="text-center medium">
                                                    Local
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody className='normal font__size--24 text__24-1024 play'>
                                            {
                                                data.map((obj) => {
                                                    return <tr>
                                                        <th scope="row"
                                                            className='text-left normal'>
                                                            {obj.title}
                                                        </th>
                                                        <td>{obj.type == "text" ? obj.path_1 : <img className="mx-auto" src={obj.path_1} alt="" />}</td>
                                                    </tr>
                                                })
                                            }

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="items">
                                <div className="wrapper__table-compare-group">
                                    <table class="table head text-center">
                                        <col class="w-f-first" />
                                        <thead>
                                            <tr className='text-center medium font__size--24 text__24-1024 play'>
                                                <th scope="col" className="text-left medium">Characteristic</th>
                                                <th scope="col" className="text-center medium">
                                                    Standard
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody className='normal font__size--24 text__24-1024 play'>
                                            {
                                                data.map((obj) => {
                                                    return <tr>
                                                        <th scope="row"
                                                            className='text-left normal'>
                                                            {obj.title}
                                                        </th>
                                                        <td>{obj.type == "text" ? obj.path_2 : <img className="mx-auto" src={obj.path_2} alt="" />}</td>
                                                    </tr>
                                                })
                                            }

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="items">
                                <div className="wrapper__table-compare-group">
                                    <table class="table head text-center">
                                        <col class="w-f-first" />
                                        <thead>
                                            <tr className='text-center medium font__size--24 text__24-1024 play'>
                                                <th scope="col" className="text-left medium">Characteristic</th>
                                                <th scope="col" className="text-center medium">
                                                    International
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody className='normal font__size--24 text__24-1024 play'>
                                            {
                                                data.map((obj) => {
                                                    return <tr>
                                                        <th scope="row"
                                                            className='text-left normal'>
                                                            {obj.title}
                                                        </th>
                                                        <td>{obj.type == "text" ? obj.path_3 : <img className="mx-auto" src={obj.path_3} alt="" />}</td>
                                                    </tr>
                                                })
                                            }

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </Slider>
                    </div>

                    <div className="wrapper__table-compare-group d-none d-lg-block">
                        <table class="table head text-center">
                            <col class="w-f-first" />
                            <thead>
                                <tr className='text-center medium font__size--24 text__24-1024 play'>
                                    <th scope="col" className="text-left medium">Characteristic</th>
                                    <th scope="col" className="text-center medium">
                                        Local
                                    </th>
                                    <th scope="col" className="text-center medium">
                                        Standard
                                    </th>
                                    <th scope="col" className="text-center medium">
                                        International
                                    </th>
                                </tr>
                            </thead>
                            <tbody className='normal font__size--24 text__24-1024 play'>
                                {
                                    data.map((obj) => {
                                        return <tr>
                                            <th scope="row" cl
                                                className='text-left normal'>
                                                {obj.title}
                                            </th>
                                            <td>{obj.type == "text" ? obj.path_1 : <img src={obj.path_1} alt="" />}</td>
                                            <td>{obj.type == "text" ? obj.path_2 : <img src={obj.path_2} alt="" />}</td>
                                            <td>{obj.type == "text" ? obj.path_3 : <img src={obj.path_3} alt="" />}</td>
                                        </tr>
                                    })
                                }

                            </tbody>
                        </table>
                    </div>
                </div>
            </section>

            <Faq />

            <Contact />

            <Footer />
        </div >
    )
}

export default Plan